import { FC } from "react"
import { useTranslation } from "react-i18next"

import AlertModal from "components/AlertModal/AlertModal"
import Status, { StatusType } from "components/Status/Status"

interface ICustomerNumberBlockedModalProps {
    customerNumber: string
    isBusy?: boolean
    onClose(): void
}

const CustomerNumberBlockedModal: FC<ICustomerNumberBlockedModalProps> = ({
    customerNumber,
    isBusy,
    onClose,
}) => {
    const { t }  = useTranslation()

    return (
        <AlertModal
            title={t('common.attention')}
            maxWidth="586px"
            onClose={onClose}
            isBusy={isBusy}>
            <Status type={StatusType.prohibit}>
                <strong>{t('outgoingInvoices.customerNo')}: {customerNumber}</strong>
            </Status>
            <div className="mt-3">
                {t('common.customerNumberBlockedNoInvoices')}
            </div>
        </AlertModal>
    )
}

export default CustomerNumberBlockedModal
